'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _SvgContainer = require('./SvgContainer');
var _SvgContainer2 = _interopRequireDefault(_SvgContainer);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var WarningSharp = function WarningSharp(props) {
  return _react2.default.createElement(_SvgContainer2.default, {
    height: props.height,
    width: props.width,
    color: props.color,
    onClick: props.onClick,
    rotate: props.rotate ? 1 : 0,
    shake: props.shake ? 1 : 0,
    beat: props.beat ? 1 : 0,
    className: props.className
  }, _react2.default.createElement('svg', {
    style: props.style,
    className: props.cssClasses,
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 512 512'
  }, props.title ? _react2.default.createElement('title', null, props.title) : '', _react2.default.createElement('path', {
    d: 'M479 447.77L268.43 56.64a8 8 0 00-14.09 0L43.73 447.77a8 8 0 007.05 11.79H472a8 8 0 007-11.79zm-197.62-36.29h-40v-40h40zm-4-63.92h-32l-6-160h44z'
  })));
};
WarningSharp.defaultProps = {
  // style
  style: {},
  color: '#000000',
  height: '22px',
  width: '22px',
  cssClasses: '',
  title: '',
  // animation
  shake: false,
  beat: false,
  rotate: false
};
WarningSharp.propTypes = {
  // style
  style: _propTypes2.default.object,
  color: _propTypes2.default.string,
  height: _propTypes2.default.string,
  width: _propTypes2.default.string,
  cssClasses: _propTypes2.default.string,
  title: _propTypes2.default.string,
  // animation
  shake: _propTypes2.default.bool,
  beat: _propTypes2.default.bool,
  rotate: _propTypes2.default.bool,
  // functions
  onClick: _propTypes2.default.func
};
exports.default = WarningSharp;
module.exports = exports['default'];